export default __webpack_public_path__ + "static/media/CommercialIM.6f647e4f.svg";